import { watchEffect } from "vue";
import type { PlaygroundStatus } from "@/api/types";

const COLOURS: Record<PlaygroundStatus | "idle", string> = {
  provisioning: "#d97706",
  destroying: "#d97706",
  ready: "#16a34a",
  failed: "#dc2626",
  "failed-interrupted": "#dc2626",
  idle: "#64748b",
};

function paint(colour: string) {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <circle cx="8" cy="8" r="6" fill="${colour}"/>
  </svg>`;
  const url = "data:image/svg+xml;utf8," + encodeURIComponent(svg);
  let link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    link.type = "image/svg+xml";
    document.head.appendChild(link);
  }
  link.href = url;
}

/**
 * Flips the favicon dot colour to match the current playground status.
 * ui-ux-design.md §4: "Favicon dot flips colour on terminal state".
 */
export function useFaviconDot(getter: () => PlaygroundStatus | "idle" | null) {
  watchEffect(() => {
    const s = getter();
    paint(COLOURS[s ?? "idle"]);
  });
}
